'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _locationChangeListener = require('./utils/locationChangeListener');

var _locationChangeListener2 = _interopRequireDefault(_locationChangeListener);

var _SessionView = require('./events/SessionView');

var _SessionView2 = _interopRequireDefault(_SessionView);

var _SessionHeartbeat = require('./events/SessionHeartbeat');

var _SessionHeartbeat2 = _interopRequireDefault(_SessionHeartbeat);

var _createTracker = require('./utils/createTracker');

var _createTracker2 = _interopRequireDefault(_createTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SessionActivitySnowplowTracker = function () {
  function SessionActivitySnowplowTracker(config, context) {
    _classCallCheck(this, SessionActivitySnowplowTracker);

    if (this.instance) {
      return this.instance;
    }

    this.instance = this;
    this.__type = 'SessionActivitySnowplowTracker';

    this.teamContext;
    this.userContext;

    this.heartbeat;
    this.sessionView;

    this.boundTrackSession;
    this.boundHeartbeat;

    var appVersion = config.appVersion,
        globalSnowplowName = config.globalSnowplowName,
        hasSessionHeartbeat = config.hasSessionHeartbeat,
        intervalMs = config.intervalMs,
        shouldTrackSessionView = config.shouldTrackSessionView,
        trackerName = config.trackerName,
        trackerSettings = config.trackerSettings,
        userId = config.userId;


    this.context = context;
    this.shouldTrackSessionView = shouldTrackSessionView;
    this.hasSessionHeartbeat = hasSessionHeartbeat;

    (0, _createTracker2.default)(globalSnowplowName, userId, trackerName, trackerSettings);

    if (this.shouldTrackSessionView) {
      this.sessionView = new _SessionView2.default({ globalSnowplowName: globalSnowplowName, appVersion: appVersion }, this.context);

      (0, _locationChangeListener2.default)();
    }

    if (this.hasSessionHeartbeat) {
      this.heartbeat = new _SessionHeartbeat2.default({ globalSnowplowName: globalSnowplowName, appVersion: appVersion, intervalMs: intervalMs }, this.context);
    }
  }

  _createClass(SessionActivitySnowplowTracker, [{
    key: 'destructor',
    value: function destructor() {
      if (this.shouldTrackSessionView) {
        this.sessionView.destructor();
      }

      if (this.hasSessionHeartbeat) {
        this.heartbeat.destructor();
      }

      this.stop();

      this.instance = null;
    }
  }, {
    key: 'appendContext',
    value: function appendContext(context) {
      if (this.shouldTrackSessionView) {
        this.sessionView.appendEventContext(context);
      }

      if (this.hasSessionHeartbeat) {
        this.heartbeat.appendEventContext(context);
      }
    }
  }, {
    key: 'setContext',
    value: function setContext(context) {
      if (this.shouldTrackSessionView) {
        this.sessionView.setEventContext(context);
      }

      if (this.hasSessionHeartbeat) {
        this.heartbeat.setEventContext(context);
      }
    }
  }, {
    key: 'updateHeartbeatIntervalMs',
    value: function updateHeartbeatIntervalMs(intervalMs) {
      if (this.hasSessionHeartbeat) {
        this.heartbeat.updateHeartbeatIntervalMs(intervalMs);
      }
    }
  }, {
    key: 'start',
    value: function start() {
      var _this = this;

      if (this.shouldTrackSessionView) {
        this.sessionView.track();

        this.boundTrackSession = function () {
          _this.sessionView.track();
        };

        window.addEventListener('locationChange', this.boundTrackSession);
      }

      if (this.hasSessionHeartbeat) {
        this.heartbeat.start();

        window.addEventListener('focus', function () {
          _this.heartbeat.start();
        });
        window.addEventListener('blur', function () {
          _this.heartbeat.stop();
        });
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var _this2 = this;

      if (this.shouldTrackSessionView) {
        window.removeEventListener('locationChange', this.boundTrackSession);
      }

      if (this.hasSessionHeartbeat) {
        this.heartbeat.stop();

        window.removeEventListener('focus', function () {
          _this2.heartbeat.start();
        });
        window.removeEventListener('blur', function () {
          _this2.heartbeat.stop();
        });
      }
    }
  }]);

  return SessionActivitySnowplowTracker;
}();

exports.default = SessionActivitySnowplowTracker;
module.exports = exports['default'];